export interface CreateQRForm {
  ref1: string;
  ref2?: string;
  amount: string;
  description?: string;
  acqRequesterId: string;
}

export enum CreateQrFieldNames {
  Ref1 = 'ref1',
  Ref2 = 'ref2',
  Amount = 'amount',
  Description = 'description',
  AcqRequesterId = 'acqRequesterId',
}
